import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
} from '@mui/material';

const Interventions = ({
  dataPoint,
  index,
  handleFieldChange,
  allGoalData,
}) => {
  const hasInterventions =
    allGoalData?.DataCollection?.HasInterventions === 'Yes';

  const availableInterventions =
    allGoalData?.DataCollection?.Interventions || [];

  const selectedInterventions = dataPoint?.interventions || [];

  const handleInterventionChange = (event) => {
    const value = event.target.value;
    handleFieldChange(index, 'interventions', value);
  };

  if (!hasInterventions || availableInterventions.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 2, mt: 2 }}>
      <Typography variant='body1' sx={{ mb: 1 }}>
        Interventions:
      </Typography>
      <FormControl fullWidth>
        <Select
          multiple
          value={selectedInterventions}
          onChange={handleInterventionChange}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} size='small' />
              ))}
            </Box>
          )}
          sx={{ minHeight: 56 }}
        >
          {availableInterventions.map((intervention) => (
            <MenuItem key={intervention} value={intervention}>
              <Checkbox
                checked={selectedInterventions.includes(intervention)}
              />
              <ListItemText primary={intervention} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default Interventions;
